export const DRAFT_STATE_KEY = "pawsome_questionnaire_draft_v1";
export const DRAFT_SESSION_KEY = "pawsome_questionnaire_session_v1";
export const PETS_KEY = "pawsome_pets";
export const DONE_KEY = "pawsome_order_complete";

export const backendUrl = () => (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const readJson = (key, fallback = null) => {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
};

export const writeLocalDraft = (state) => {
  localStorage.setItem(DRAFT_STATE_KEY, JSON.stringify(state));
};

export const readLocalDraft = () => readJson(DRAFT_STATE_KEY, null);
export const readDraftSession = () => readJson(DRAFT_SESSION_KEY, null);
export const writeDraftSession = (session) => localStorage.setItem(DRAFT_SESSION_KEY, JSON.stringify(session));

export const clientKey = () => {
  const existing = localStorage.getItem("pawsome_draft_client_key");
  if (existing) return existing;
  const value = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}-${Math.random()}`;
  localStorage.setItem("pawsome_draft_client_key", value);
  return value;
};

const headers = (token) => ({
  "Content-Type": "application/json",
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

const newResumeToken = () => {
  const bytes = new Uint8Array(48);
  globalThis.crypto.getRandomValues(bytes);
  return btoa(String.fromCharCode(...bytes)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const parse = async (response) => {
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(typeof body.detail === "string" ? body.detail : body.detail?.message || "Draft could not be saved.");
    error.status = response.status;
    error.body = body;
    throw error;
  }
  return body;
};

export const createDraft = async ({ email, confirmEmail, payload }) => {
  const pendingKey="pawsome_draft_pending_token";
  const token=localStorage.getItem(pendingKey)||newResumeToken();
  localStorage.setItem(pendingKey,token);
  const result=await parse(await fetch(`${backendUrl()}/api/public/drafts`, {
    method: "POST", headers: headers(token), body: JSON.stringify({ email, confirm_email: confirmEmail, client_key: clientKey(), payload }),
  }));
  localStorage.removeItem(pendingKey);
  return {...result,resume_token:token};
};

export const saveDraft = async ({ token, version, payload, keepalive = false }) => parse(await fetch(`${backendUrl()}/api/public/drafts/current`, {
  method: "PUT", headers: headers(token), keepalive, body: JSON.stringify({ expected_version: version, payload }),
}));

export const resumeDraft = async (token) => parse(await fetch(`${backendUrl()}/api/public/drafts/resume`, {
  method: "GET", headers: headers(token), cache: "no-store",
}));

export const reopenDraft = async (token) => parse(await fetch(`${backendUrl()}/api/public/drafts/reopen`, {
  method: "POST", headers: headers(token),
}));

export const resumeTokenFromLocation = () => {
  const match = window.location.hash.match(/(?:^#|&)resume=([^&]+)/);
  if (!match) return null;
  const token = decodeURIComponent(match[1]);
  window.history.replaceState({}, "", `${window.location.pathname}${window.location.search}`);
  return token;
};

export const clearCompletedDraft = () => {
  localStorage.removeItem(DRAFT_STATE_KEY);
  localStorage.removeItem(DRAFT_SESSION_KEY);
  localStorage.removeItem(PETS_KEY);
  localStorage.removeItem(DONE_KEY);
  localStorage.removeItem("pawsome_draft_client_key");
  localStorage.removeItem("pawsome_draft_pending_token");
};
